import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { Table, Tag, Button, Modal, Alert } from 'antd'
import { connect } from 'react-redux'
import { permissionTranslation, getWithDrawer } from '../../utils'
import PermissionRequest from './permissionRequest'
import './myPermissions.css'

export class MyPermissions extends Component {
  constructor(props) {
    super(props)
    const { intl } = this.props
    this.columns = [
      {
        key: '1',
        title: intl.formatMessage({ id: "my_groups" }),
        dataIndex: 'name',
      }, {
        key: '2',
        title: intl.formatMessage({ id: "permissions" }),
        dataIndex: 'permission',
        render: (text, data) => (
          <span>{data.permissions.map((r, k) => <Tag style={{ marginBottom: 5 }} key={k} color={r.enabled ? '#87d068' : '#f50'}>{permissionTranslation(r.action, intl)}</Tag>)}</span>
        )
      }, {
        key: '3',
        title: intl.formatMessage({ id: "created_by" }),
        dataIndex: 'creatorEmail',
      }, {
        key: '4',
        title: intl.formatMessage({ id: "request_permissions" }),
        render: row => {
          return (
            <Button type="primary" size="small" onClick={() => this.handleClickButton(row)}>{intl.formatMessage({ id: "request" })}</Button>
          )
        }
      }]
    this.state = {
      dataSource: [],
      showPermissionRequest: false,
      itemButton: null
    }
  }

  componentDidMount() {
    const { user, group } = this.props

    this.setState({
      dataSource: group.filter(r => r.users.find(u => u._id === user._id)).map((r, k) => {
        return {
          key: k,
          _id: r._id,
          name: r.name,
          permissions: r.permissions,
          creatorId: r.userCreator.id,
          creatorEmail: r.userCreator.email,
          creatorName: r.userCreator.name
        }
      })
    })
  }

  handleClickButton = (item) => {
    this.setState({
      showPermissionRequest: true,
      itemButton: item
    })
  }

  handleHidePermissionRequest = () => {
    this.setState({
      showPermissionRequest: false,
    })
  }

  render() {

    const { dataSource, showPermissionRequest, itemButton } = this.state
    const { intl, user } = this.props

    return (
      <React.Fragment >
        {(user.role === 'admin' || user.clientRole === 'admin') &&
          <Alert
            style={{ marginBottom: '36px' }}
            message={intl.formatMessage({ id: "information" })}
            description={intl.formatMessage({ id: "information_mypermissions" })}
            type="info"
            showIcon
          />}
        <Table
          dataSource={dataSource}
          columns={this.columns}
          bordered={true}
          size={"middle"} />
        <Modal
          title={intl.formatMessage({ id: "permission_request" })}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHidePermissionRequest}
          onClose={this.handleHidePermissionRequest}
          visible={showPermissionRequest}>
          {showPermissionRequest && <PermissionRequest
            item={itemButton}
            handleHidePermissionRequest={this.handleHidePermissionRequest}
          />}
        </Modal>
      </React.Fragment >
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.authUser.user,
  group: state.group.byClientData,
  width: state.app.width
})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(MyPermissions)))